import { render, staticRenderFns } from "./GenerateCard.vue?vue&type=template&id=21410f1c&"
import script from "./GenerateCard.vue?vue&type=script&lang=js&"
export * from "./GenerateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports